import { InMemoryCache, makeVar } from '@apollo/client';

export const sessionVar = makeVar({});
export const requestModelAmountVar = makeVar(false);

export const cache = new InMemoryCache();
